import React from 'react';
import { Box, Typography } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';

const Footer = () => {
    return (
        <Box
            sx={{
                py: 2,
                px: 3,
                textAlign: 'center',
                backgroundColor: '#f1f1f1',
                borderTop: '1px solid #ddd',
                mt: 'auto',
            }}
        >
            <Typography variant="body2" color="text.secondary" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                ©  {new Date().getFullYear()} शिवअंबा पूजा साहित्य व प्रासादिक भांडार 
                <FavoriteIcon fontSize="small" color="error" sx={{ ml: 0.5 }} />
            </Typography>
        </Box>
    );
};

export default Footer;
